import { RecipientTypeEnum } from 'Modules/Communication/shared/models/Inbox'
import { isValidMobileNumber } from 'shared/components/SendMessageHandler/shared/utils/send-sms-helper'
import { isNotNullOrUndefined } from 'shared/utils/types'
import { SystemState } from './types'

export const getSendSms = (state: SystemState) => state.sendMessage.sms

export const getSendSmsId = (state: SystemState) =>
  state.sendMessage.sms.messageId

export const getSendSmsRecipients = (state: SystemState) =>
  state.sendMessage.sms.message?.recipients || []

export const getSmsReciept = (state: SystemState) =>
  state.sendMessage.sms.reciept

export const getIsSmsCollapsed = (state: SystemState) => {
  return state.sendMessage.sms.isCollapsed
}

export const getSmsRecipientsWithInvalidCount =
  (recipientType: RecipientTypeEnum) => (state: SystemState) => {
    const allRecipients = getSendSmsRecipients(state)

    const recipients = allRecipients.filter(
      (recipient) => recipient.recipientType === recipientType
    )

    const invalidRecipients = recipients.filter(
      (recipient) => !isValidMobileNumber(recipient.phonenumber || '')
    )

    const invalidOrDuplicate = recipients.filter((recipient) => {
      const { nameregisterId, phonenumber } = recipient

      const isDuplicate = allRecipients.some(
        (rec) =>
          ((isNotNullOrUndefined(rec.nameregisterId) &&
            isNotNullOrUndefined(nameregisterId) &&
            rec.nameregisterId === nameregisterId) ||
            (isNotNullOrUndefined(rec.phonenumber) &&
              isNotNullOrUndefined(phonenumber) &&
              rec.phonenumber === phonenumber)) &&
          rec?.recipientType !== recipientType
      )

      const isInvalid = invalidRecipients.some(
        (rec) =>
          (isNotNullOrUndefined(rec.phonenumber) &&
            isNotNullOrUndefined(phonenumber) &&
            rec.phonenumber === phonenumber) ||
          rec.nameregisterId === nameregisterId
      )
      return isInvalid || isDuplicate
    }).length

    return {
      recipients,
      invalidOrDuplicate,
    }
  }

export const getSmsRecipientsLoading = (state: SystemState) => {
  return getSendSms(state).recipientLoadingQueue
}
